// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Alert_backdrop__Cx4_4","modal":"Alert_modal__3ZvLN"};